export default __webpack_public_path__ + "static/image/product.a9c07f23.jpg";